import IWebGLDestructible from './IWebGLDestructible';
import LogGL from "mediamonks-webgl/renderer/core/LogGL";

export default class WebGLDestructible implements IWebGLDestructible {
  public isDestructed: boolean = false;

  public destruct(): void {
    if (this.isDestructed) {
      LogGL.error('Cannot destruct twice');
    }
    this.isDestructed = true;
  }
}